/* Svensk katalog for locale-invoice-detail-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inv.pay.originalAmount': 'Belopp i {currency}',
  'inv.pay.bankAmountCurrency': 'Bankbelopp i {currency}',
  'inv.pay.fxPreview': 'Fordran stängs med {receivable} {accountingCurrency}. Skillnaden mot bankbeloppet bokförs som {kind}: {difference}.',
  'inv.pay.fxGain': 'valutavinst',
  'inv.pay.fxLoss': 'valutaförlust',
});
